import { useState } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { CopyIDMenuItem } from '#components/patterns/menus/meatball-menu/CopyIDMenuItem.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import type { Network } from '#dn-types/network.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { DeleteNetworkModal } from '../../delete/DeleteNetworkModal.tsx';
import { UpdateNetworkModal } from '../../update/UpdateNetworkModal.tsx';
import styles from './NetworkActionMenu.module.css';

type Props = {
  networkId: string;
  certVersion: Network['certVersion'];
};

export function NetworkActionMenu({ networkId, certVersion }: Props) {
  const location = useAppLocation();

  const [networkBeingDeletedId, setNetworkBeingDeletedId] = useState<string | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <>
      <MeatballMenu className={styles.NetworkActionMenu}>
        <CopyIDMenuItem id={networkId} />
        <MenuItem render={<Link to={networkId} state={{ from: location }} />}>Edit</MenuItem>
        {certVersion === 1 ?
          <MenuItem onClick={() => setIsUpdating(true)}>Update</MenuItem>
        : null}
        <MenuItem onClick={() => setNetworkBeingDeletedId(networkId)}>Delete</MenuItem>
      </MeatballMenu>
      {networkBeingDeletedId ?
        <DeleteNetworkModal
          networkId={networkId}
          onClose={() => {
            setNetworkBeingDeletedId(null);
          }}
          onDelete={() => {
            setNetworkBeingDeletedId(null);
          }}
        />
      : null}
      {isUpdating ?
        <UpdateNetworkModal
          networkId={networkId}
          onClose={() => setIsUpdating(false)}
          onUpdate={() => setIsUpdating(false)}
        />
      : null}
    </>
  );
}
